import { ChartOptionsProvider, CHART_FLEXED_MARKER } from './chart-options';
import { Injectable } from '@angular/core';

@Injectable()
export class HistoricImpliedIroceOptionsProvider extends ChartOptionsProvider {
    getOptions(company) {
      if (!company.historic_iroce_expectation) {
        return;
      }
        const historicIroceExpectation = company.historic_iroce_expectation;
        const currentDate = new Date();
        currentDate.setHours(1,0,0,0);
        const iroceExpectation = company.platformData.iroceExpectation;

    let chartOptions = {
      chart: { spacingBottom:20, type: 'line' },
      title: 'Historic Implied IROCE (%)',
      legend: {
        enabled: false
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
            year: '%Y'
        }
      },
      yAxis: {
        labels: {
          x: 0
        },
        min: 0,
        max: Math.max(...historicIroceExpectation.map(item => 100 * parseFloat(item.value)))+2,
        minTickInterval: 1,
        title: {
          text: null
        }
      },
      tooltip: this.defaultChartOptions.tooltip,
      series: [,,,
        {
          name: 'Historic Implied IROCE (%)',
          data: [...historicIroceExpectation.map(item => [new Date(item.date).getTime() , 100 * parseFloat(item.value)]), [currentDate.getTime(), iroceExpectation*100]],
          marker: {
            enabled: false
          },
          visible: true
        }]
    }

    chartOptions = this.setYMax(chartOptions);
    chartOptions = this.setYMin(chartOptions);
        return super.getOptions(company, chartOptions);
    };
}



// WEBPACK FOOTER //
// ./src/providers/chart-options/historic-implied-iroce.ts